/**
 * HW Gifts - Artwork Submission Script
 *
 * Add this script to the Shopify product-designer page.
 * It reads token/ref from URL params, validates via Firebase,
 * auto-opens the FPD customiser, dynamically loads the correct
 * FPD product config, and submits the finished design.
 *
 * Flow: Customer designs -> FPD add-to-cart (registers with FPD backend)
 *       -> read cart -> create real Shopify order -> clear cart -> done
 */
(function () {
  var VALIDATE_URL = 'https://validatetoken-tygmvonjbq-ew.a.run.app';
  var SUBMIT_URL = 'https://submitdesign-tygmvonjbq-ew.a.run.app';

  var params = new URLSearchParams(window.location.search);
  var token = params.get('token');
  var ref = params.get('ref');

  if (!token) return;

  var orderInfo = null;
  var submitted = false;
  var configLoaded = false;

  // -- FULL-SCREEN LOADING OVERLAY --
  function showLoadingOverlay() {
    var overlay = document.createElement('div');
    overlay.id = 'artwork-loading-overlay';
    overlay.style.cssText =
      'position: fixed; top: 0; left: 0; right: 0; bottom: 0; z-index: 999999;' +
      'background: #f9fafb; display: flex; flex-direction: column; align-items: center; justify-content: center;' +
      'font-family: system-ui, -apple-system, sans-serif; transition: opacity 0.4s ease;';
    overlay.innerHTML =
      '<div style="text-align: center;">' +
      '<div style="width: 48px; height: 48px; border: 3px solid #e5e7eb; border-top-color: #4f46e5; border-radius: 50%; animation: artworkSpin 0.8s linear infinite; margin: 0 auto 20px;"></div>' +
      '<p style="font-size: 18px; font-weight: 600; color: #111827; margin: 0 0 6px;">Preparing Your Designer</p>' +
      '<p id="artwork-loading-msg" style="font-size: 14px; color: #6b7280; margin: 0;">Loading your order details...</p>' +
      '</div>';

    var spinStyle = document.createElement('style');
    spinStyle.textContent = '@keyframes artworkSpin { to { transform: rotate(360deg); } }';
    document.head.appendChild(spinStyle);

    document.body.appendChild(overlay);
  }

  function updateLoadingMsg(msg) {
    var el = document.getElementById('artwork-loading-msg');
    if (el) el.textContent = msg;
  }

  function hideLoadingOverlay() {
    var overlay = document.getElementById('artwork-loading-overlay');
    if (overlay) {
      overlay.style.opacity = '0';
      setTimeout(function () {
        overlay.remove();
      }, 400);
    }
  }

  // -- INJECT CLEAN LAYOUT CSS --
  function injectCleanLayout() {
    var style = document.createElement('style');
    style.textContent =
      '#shopify-section-header,' +
      '#shopify-section-footer,' +
      '#shopify-section-announcement-bar,' +
      'header,' +
      'footer,' +
      '.announcement-bar,' +
      '.header-wrapper,' +
      '.footer,' +
      '.site-header,' +
      '.site-footer,' +
      '#header,' +
      '#footer,' +
      '.shopify-section--header,' +
      '.shopify-section--footer,' +
      '.product__description,' +
      '.product__info-wrapper .price,' +
      '.product__title,' +
      '.product__text,' +
      '.product-single__description,' +
      '.product__media-list,' +
      '.product__media-wrapper,' +
      '.product-single__photos,' +
      '.product__info-container .price,' +
      '.product-single__title,' +
      '.share-buttons,' +
      '.product__pickup-availabilities,' +
      '.product-form,' +
      '.product-form__submit,' +
      '.shopify-payment-button,' +
      '.product-form__buttons,' +
      '.announcement-bar-section' +
      '{ display: none !important; }' +
      '#fpd-customize-button { display: none !important; }' +
      'body { padding-top: 0 !important; margin-top: 0 !important; }' +
      '.fpd-modal-overlay, .fpd-modal-wrapper, .fpd-container { z-index: 100 !important; }' +
      '#artwork-banner { z-index: 99999 !important; }' +
      '#artwork-submit-container { z-index: 99999 !important; }';
    document.head.appendChild(style);
  }

  // -- UI SETUP --
  function createUI() {
    var banner = document.createElement('div');
    banner.id = 'artwork-banner';
    banner.style.cssText =
      'background: linear-gradient(135deg, #4f46e5, #7c3aed); color: white; padding: 16px 24px; text-align: center; font-family: system-ui, sans-serif; position: sticky; top: 0; z-index: 99999; box-shadow: 0 2px 8px rgba(0,0,0,0.15);';
    banner.innerHTML =
      '<div style="max-width: 600px; margin: 0 auto;">' +
      '<p id="artwork-status" style="margin: 0; font-size: 15px; font-weight: 500;">Loading your order details...</p>' +
      '</div>';
    document.body.prepend(banner);

    var submitContainer = document.createElement('div');
    submitContainer.id = 'artwork-submit-container';
    submitContainer.style.cssText =
      'position: fixed; bottom: 0; left: 0; right: 0; z-index: 99999; padding: 16px 24px; background: white; border-top: 1px solid #e5e7eb; box-shadow: 0 -4px 12px rgba(0,0,0,0.1); display: none; text-align: center;';
    submitContainer.innerHTML =
      '<div style="max-width: 500px; margin: 0 auto;">' +
      '<p id="artwork-product-name" style="margin: 0 0 10px; font-size: 13px; color: #6b7280; font-family: system-ui, sans-serif;"></p>' +
      '<div style="display: flex; gap: 10px;">' +
      '<button id="artwork-edit-btn" style="flex: 1; padding: 14px 16px; background: #f3f4f6; color: #374151; border: 1px solid #d1d5db; border-radius: 12px; font-size: 15px; font-weight: 600; cursor: pointer; font-family: system-ui, sans-serif; transition: background 0.2s;">Edit Design</button>' +
      '<button id="artwork-submit-btn" style="flex: 2; padding: 14px 24px; background: #4f46e5; color: white; border: none; border-radius: 12px; font-size: 16px; font-weight: 600; cursor: pointer; font-family: system-ui, sans-serif; transition: background 0.2s;">Submit My Artwork</button>' +
      '</div>' +
      '<p style="margin: 8px 0 0; font-size: 11px; color: #9ca3af; font-family: system-ui, sans-serif;">Your design will be sent directly to our production team</p>' +
      '</div>';
    document.body.appendChild(submitContainer);
  }

  function setStatus(msg) {
    var el = document.getElementById('artwork-status');
    if (el) el.textContent = msg;
  }

  function showError(msg) {
    var banner = document.getElementById('artwork-banner');
    if (banner) banner.style.background = '#dc2626';
    setStatus(msg);
  }

  function showSubmitButton() {
    hideLoadingOverlay();
    var container = document.getElementById('artwork-submit-container');
    if (container) container.style.display = 'block';

    var nameEl = document.getElementById('artwork-product-name');
    if (nameEl && orderInfo) {
      nameEl.textContent = 'Designing: ' + orderInfo.productName + ' (Order: ' + (ref || '').slice(0, 8) + ')';
    }
  }

  // -- RE-OPEN FPD MODAL --
  function reopenFPD() {
    var triggerBtn = document.getElementById('fpd-customize-button');
    if (triggerBtn) {
      triggerBtn.style.setProperty('display', 'block', 'important');
      triggerBtn.click();
      setTimeout(function () {
        triggerBtn.style.setProperty('display', 'none', 'important');
      }, 500);
    }
  }

  // -- VALIDATE TOKEN --
  async function validateToken() {
    try {
      var res = await fetch(VALIDATE_URL + '?token=' + encodeURIComponent(token));
      var data = await res.json();
      if (!res.ok) {
        showError(data.error || 'This link is not valid.');
        return null;
      }
      return data;
    } catch (e) {
      showError('Unable to validate your link. Please try again later.');
      return null;
    }
  }

  // -- AUTO-OPEN FPD CUSTOMISER --
  function autoOpenFPD(callback, attempts) {
    attempts = attempts || 0;
    if (attempts > 30) {
      showError('Could not open the product designer. Please refresh.');
      return;
    }

    var triggerBtn = document.getElementById('fpd-customize-button');

    if (triggerBtn) {
      setStatus('Opening designer...');
      triggerBtn.style.setProperty('display', 'block', 'important');
      triggerBtn.click();
      setTimeout(function () {
        triggerBtn.style.setProperty('display', 'none', 'important');
      }, 500);
      setTimeout(callback, 3000);
    } else {
      setTimeout(function () {
        autoOpenFPD(callback, attempts + 1);
      }, 500);
    }
  }

  // -- WAIT FOR FPD INSTANCE TO BE FULLY READY --
  function waitForFPDReady(callback, attempts) {
    attempts = attempts || 0;
    if (attempts > 30) {
      showError('Product designer failed to load. Please refresh.');
      return;
    }

    if (
      window.FPD &&
      window.FPD.instance &&
      window.FPD.instance.getProduct &&
      window.FPD.instance.currentViewInstance &&
      window.FPD.instance.currentViewInstance.fabricCanvas
    ) {
      callback();
    } else {
      setTimeout(function () {
        waitForFPDReady(callback, attempts + 1);
      }, 500);
    }
  }

  // -- LOAD FPD CONFIG --
  function loadFPDConfig(fpdConfig) {
    if (!fpdConfig) {
      console.log('[HW] No FPD config, using default product');
      configLoaded = true;
      setStatus('Ready! Design your product and click Submit when done.');
      showSubmitButton();
      return;
    }

    var parsedConfig = fpdConfig;
    if (typeof fpdConfig === 'string') {
      try { parsedConfig = JSON.parse(fpdConfig); } catch (e) {
        console.warn('[HW] fpdConfig is not valid JSON string');
        parsedConfig = null;
      }
    }

    // If we got a product title/name string, try to select it from FPD's catalog
    if (typeof parsedConfig === 'string') {
      return selectFPDProductByTitle(parsedConfig);
    }

    // If it's not an array or is empty, skip
    if (!Array.isArray(parsedConfig) || parsedConfig.length === 0) {
      console.log('[HW] FPD config empty, using default product');
      configLoaded = true;
      setStatus('Ready! Design your product and click Submit when done.');
      showSubmitButton();
      return;
    }

    // Detect format: if items have 'elements', it's getProduct() format (correct for loadProduct)
    // If items have 'designs', it's allDesignsJSON format (product catalog)
    var hasElements = parsedConfig[0] && parsedConfig[0].elements;
    var hasDesigns = parsedConfig[0] && parsedConfig[0].designs;

    if (hasDesigns && !hasElements) {
      console.log('[HW] Config is allDesignsJSON format (catalog of', parsedConfig.length, 'products)');
      // This is the FPD product catalog, not a single product config
      // Try to find the right product using orderInfo and FPD's built-in catalog
      return selectFPDProductFromCatalog(parsedConfig);
    }

    if (hasElements) {
      console.log('[HW] Config is getProduct() format with', parsedConfig.length, 'views');
      return loadProductDirect(parsedConfig);
    }

    // Unknown format, skip loading and use default product
    console.log('[HW] Unknown config format, using default product');
    configLoaded = true;
    setStatus('Ready! Design your product and click Submit when done.');
    showSubmitButton();
    return;
  }

  function selectFPDProductByTitle(title) {
    setStatus('Selecting your product...');
    console.log('[HW] Selecting product by title:', title);

    var allDesigns = window._fpdDesigns ? window._fpdDesigns.allDesignsJSON : null;
    if (!allDesigns || !Array.isArray(allDesigns)) {
      console.warn('[HW] _fpdDesigns not available, using default');
      configLoaded = true;
      setStatus('Ready! Design your product and click Submit when done.');
      showSubmitButton();
      return;
    }

    var targetIdx = -1;
    var titleLower = title.toLowerCase();
    for (var i = 0; i < allDesigns.length; i++) {
      if (allDesigns[i].title && allDesigns[i].title.toLowerCase().indexOf(titleLower) !== -1) {
        targetIdx = i;
        break;
      }
    }

    if (targetIdx === -1) {
      for (var j = 0; j < allDesigns.length; j++) {
        if (allDesigns[j].title && titleLower.indexOf(allDesigns[j].title.toLowerCase()) !== -1) {
          targetIdx = j;
          break;
        }
      }
    }

    if (targetIdx >= 0) {
      console.log('[HW] Found product at index', targetIdx, ':', allDesigns[targetIdx].title);
      selectFPDProductByIndex(targetIdx);
    } else {
      console.warn('[HW] Product not found by title, using default');
      configLoaded = true;
      setStatus('Ready! Design your product and click Submit when done.');
      showSubmitButton();
    }
  }

  function selectFPDProductFromCatalog(catalogItems) {
    setStatus('Selecting your product...');

    var allDesigns = window._fpdDesigns ? window._fpdDesigns.allDesignsJSON : null;
    if (!allDesigns) allDesigns = catalogItems;

    // Try to match by order product title
    var orderTitle = (orderInfo && orderInfo.productName) ? orderInfo.productName.toLowerCase() : '';
    var orderSku = (orderInfo && orderInfo.sku) ? orderInfo.sku.toLowerCase() : '';
    var targetIdx = -1;

    if (orderTitle) {
      for (var i = 0; i < allDesigns.length; i++) {
        var designTitle = (allDesigns[i].title || '').toLowerCase();
        if (designTitle && (orderTitle.indexOf(designTitle) !== -1 || designTitle.indexOf(orderTitle) !== -1)) {
          targetIdx = i;
          break;
        }
      }
    }

    if (targetIdx >= 0) {
      console.log('[HW] Matched product at index', targetIdx, 'by title:', allDesigns[targetIdx].title);
      selectFPDProductByIndex(targetIdx);
    } else {
      console.log('[HW] No title match found, using default product');
      configLoaded = true;
      setStatus('Ready! Design your product and click Submit when done.');
      showSubmitButton();
    }
  }

  function selectFPDProductByIndex(idx) {
    setStatus('Loading your product template...');
    console.log('[HW] Selecting FPD product index:', idx);

    var safetyTimeout = setTimeout(function () {
      console.warn('[HW] Product selection timed out');
      configLoaded = true;
      setStatus('Ready! Design your product and click Submit when done.');
      showSubmitButton();
    }, 15000);

    try {
      if (FPD.instance.selectProduct) {
        FPD.instance.selectProduct(idx);
        console.log('[HW] selectProduct called');
      } else if (FPD.instance.loadProduct && window._fpdDesigns && window._fpdDesigns.allDesignsJSON) {
        var product = window._fpdDesigns.allDesignsJSON[idx];
        if (product && product.designs) {
          FPD.instance.loadProduct(product.designs);
          console.log('[HW] loadProduct called with designs array');
        }
      }
    } catch (e) {
      console.error('[HW] Product selection failed:', e);
    }

    setTimeout(function () {
      clearTimeout(safetyTimeout);
      configLoaded = true;
      setStatus('Ready! Design your product and click Submit when done.');
      showSubmitButton();
    }, 4000);
  }

  function loadProductDirect(config) {
    setStatus('Loading your product template...');

    var safetyTimeout = setTimeout(function () {
      console.warn('[HW] Direct load timed out');
      configLoaded = true;
      setStatus('Ready! Design your product and click Submit when done.');
      showSubmitButton();
    }, 15000);

    try {
      FPD.instance.reset();
    } catch (e) {
      console.warn('[HW] Reset failed:', e);
    }

    function waitForCanvas(cb, retries) {
      retries = retries || 0;
      if (retries > 30) { cb(); return; }
      if (FPD.instance && FPD.instance.currentViewInstance && FPD.instance.currentViewInstance.fabricCanvas) {
        cb();
      } else {
        setTimeout(function () { waitForCanvas(cb, retries + 1); }, 500);
      }
    }

    setTimeout(function () {
      waitForCanvas(function () {
        try {
          FPD.instance.loadProduct(config);
          console.log('[HW] loadProduct called');
        } catch (e) {
          console.error('[HW] loadProduct failed:', e);
        }
        setTimeout(function () {
          clearTimeout(safetyTimeout);
          configLoaded = true;
          setStatus('Ready! Design your product and click Submit when done.');
          showSubmitButton();
        }, 3000);
      });
    }, 1500);
  }

  // -- BLOCK AND RESTORE ALL NAVIGATION --
  var _navBlock = {
    active: false,
    origAssign: null,
    origReplace: null,
    origFormSubmit: null,
    origHrefSet: null,
    origOpen: null,
    docHandler: null,
  };

  function blockAllNavigation() {
    _navBlock.active = true;

    // 1. Override location.assign / location.replace
    _navBlock.origAssign = window.location.assign.bind(window.location);
    _navBlock.origReplace = window.location.replace.bind(window.location);
    window.location.assign = function (url) {
      console.log('[HW] Blocked location.assign:', url);
    };
    window.location.replace = function (url) {
      console.log('[HW] Blocked location.replace:', url);
    };

    // 2. Override location.href setter (catches window.location.href = '/cart')
    try {
      var desc = Object.getOwnPropertyDescriptor(Location.prototype, 'href');
      if (desc && desc.set) {
        _navBlock.origHrefSet = desc.set;
        Object.defineProperty(Location.prototype, 'href', {
          get: desc.get,
          set: function (val) {
            if (_navBlock.active) {
              console.log('[HW] Blocked location.href set:', val);
              return;
            }
            return _navBlock.origHrefSet.call(this, val);
          },
          configurable: true,
          enumerable: true,
        });
      }
    } catch (e) {
      console.warn('[HW] Could not override location.href setter:', e);
    }

    // 3. Override HTMLFormElement.prototype.submit (catches programmatic form.submit())
    _navBlock.origFormSubmit = HTMLFormElement.prototype.submit;
    HTMLFormElement.prototype.submit = function () {
      if (_navBlock.active && this.action && this.action.indexOf('/cart') !== -1) {
        console.log('[HW] Blocked form.submit() to:', this.action);
        var formData = new FormData(this);
        fetch('/cart/add.js', { method: 'POST', body: formData }).catch(function () {});
        return;
      }
      return _navBlock.origFormSubmit.call(this);
    };

    // 4. Document-level submit event capture (catches click-triggered submits)
    _navBlock.docHandler = function (e) {
      var form = e.target;
      if (form.action && form.action.indexOf('/cart') !== -1) {
        e.preventDefault();
        e.stopImmediatePropagation();
        console.log('[HW] Blocked submit event to:', form.action);
        var formData = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: formData }).catch(function () {});
      }
    };
    document.addEventListener('submit', _navBlock.docHandler, true);

    // 5. Override window.open just in case
    _navBlock.origOpen = window.open;
    window.open = function () {
      console.log('[HW] Blocked window.open');
    };
  }

  function restoreAllNavigation() {
    _navBlock.active = false;

    if (_navBlock.origAssign) window.location.assign = _navBlock.origAssign;
    if (_navBlock.origReplace) window.location.replace = _navBlock.origReplace;

    if (_navBlock.origHrefSet) {
      try {
        var desc = Object.getOwnPropertyDescriptor(Location.prototype, 'href');
        Object.defineProperty(Location.prototype, 'href', {
          get: desc.get,
          set: _navBlock.origHrefSet,
          configurable: true,
          enumerable: true,
        });
      } catch (e) {}
    }

    if (_navBlock.origFormSubmit) {
      HTMLFormElement.prototype.submit = _navBlock.origFormSubmit;
    }

    if (_navBlock.docHandler) {
      document.removeEventListener('submit', _navBlock.docHandler, true);
    }

    if (_navBlock.origOpen) window.open = _navBlock.origOpen;
  }

  // -- TRIGGER FPD's NATIVE ADD-TO-CART SILENTLY --
  async function triggerFPDAddToCart() {
    await fetch('/cart/clear.js', { method: 'POST' });

    blockAllNavigation();

    // Find and click the add-to-cart button (FPD intercepts this to cache the design)
    var addBtn = document.querySelector(
      'button[name="add"], form[action="/cart/add"] button[type="submit"], ' +
      '.product-form__submit, [data-action="add-to-cart"]'
    );
    var productForm = document.querySelector(
      'form[action="/cart/add"], form[action*="/cart/add"], product-form form'
    );

    if (addBtn) {
      addBtn.style.setProperty('display', 'block', 'important');
      addBtn.style.setProperty('visibility', 'hidden', 'important');
      addBtn.style.setProperty('position', 'absolute', 'important');
      addBtn.style.setProperty('pointer-events', 'auto', 'important');
      addBtn.style.setProperty('opacity', '0', 'important');
      addBtn.click();
      console.log('[HW] Clicked add-to-cart button');
    } else if (productForm) {
      var submitBtn = productForm.querySelector('[type="submit"], button');
      if (submitBtn) {
        submitBtn.style.setProperty('display', 'block', 'important');
        submitBtn.style.setProperty('visibility', 'hidden', 'important');
        submitBtn.style.setProperty('position', 'absolute', 'important');
        submitBtn.style.setProperty('pointer-events', 'auto', 'important');
        submitBtn.style.setProperty('opacity', '0', 'important');
        submitBtn.click();
        console.log('[HW] Clicked form submit button');
      }
    } else {
      console.warn('[HW] No add-to-cart button found');
    }

    // Wait for FPD to process the design and add to cart
    var cart = null;
    for (var attempt = 0; attempt < 15; attempt++) {
      await new Promise(function (r) { setTimeout(r, 1000); });
      try {
        var cartRes = await fetch('/cart.js');
        cart = await cartRes.json();
        console.log('[HW] Cart poll attempt', attempt + 1, '- items:', cart.items ? cart.items.length : 0);
        if (cart && cart.items && cart.items.length > 0) {
          var hasFpd = cart.items.some(function (item) {
            return item.properties && item.properties['_fpd-hash'];
          });
          if (hasFpd) {
            console.log('[HW] FPD properties found in cart');
            break;
          }
        }
      } catch (e) {
        console.warn('[HW] Cart poll error:', e);
      }
    }

    restoreAllNavigation();

    return cart;
  }

  // -- SUBMIT DESIGN --
  async function submitDesign() {
    if (submitted) return;
    if (!configLoaded) {
      alert('Please wait for the designer to finish loading.');
      return;
    }

    var btn = document.getElementById('artwork-submit-btn');
    btn.textContent = 'Submitting...';
    btn.style.background = '#6b7280';
    btn.disabled = true;
    setStatus('Capturing your design...');

    try {
      var fpd = FPD.instance;

      // Preview images
      var images = await new Promise(function (resolve) {
        fpd.getViewsDataURL(function (urls) {
          resolve(urls);
        });
      });

      // Print-quality images
      var printImages = await new Promise(function (resolve) {
        fpd.getViewsDataURL(function (urls) {
          resolve(urls);
        }, { multiplier: 3 });
      });

      var designData = fpd.getProduct();

      setStatus('Registering your design...');

      // Trigger FPD's native add-to-cart so it caches the design in FPD's backend
      // This happens silently -- the customer stays on this page
      var cart = await triggerFPDAddToCart();
      console.log('[HW] Cart after FPD add-to-cart:', cart);

      // Extract the cart items with FPD properties (_fpd-hash, _fpd-url, _fpd-handle)
      var cartItems = [];
      if (cart && cart.items && cart.items.length > 0) {
        cartItems = cart.items.map(function (item) {
          return {
            variant_id: item.variant_id,
            quantity: item.quantity,
            properties: item.properties || {},
          };
        });
      }

      if (cartItems.length === 0) {
        console.warn('[HW] No cart items captured, falling back to direct order creation');
      }

      setStatus('Creating your order...');

      // Submit everything to our Cloud Function
      var res = await fetch(SUBMIT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          token: token,
          images: images,
          printImages: printImages,
          designData: designData,
          cartItems: cartItems,
        }),
      });

      var result = await res.json();
      if (!res.ok) throw new Error(result.error || 'Submission failed');

      // Clear the cart
      await fetch('/cart/clear.js', { method: 'POST' });

      submitted = true;

      var banner = document.getElementById('artwork-banner');
      banner.style.background = 'linear-gradient(135deg, #059669, #10b981)';
      setStatus('Design submitted successfully! You can close this page.');

      var container = document.getElementById('artwork-submit-container');
      container.innerHTML =
        '<div style="max-width: 500px; margin: 0 auto; text-align: center; padding: 8px 0;">' +
        '<p style="margin: 0; font-size: 16px; font-weight: 600; color: #059669; font-family: system-ui, sans-serif;">Design Submitted Successfully</p>' +
        '<p style="margin: 4px 0 0; font-size: 13px; color: #6b7280; font-family: system-ui, sans-serif;">Thank you! We\'ll get started on your order.</p>' +
        '</div>';
    } catch (e) {
      showError('Failed to submit: ' + e.message + '. Please try again.');
      btn.textContent = 'Retry Submit';
      btn.style.background = '#4f46e5';
      btn.disabled = false;
    }
  }

  // -- INIT --
  async function init() {
    showLoadingOverlay();
    injectCleanLayout();
    createUI();

    updateLoadingMsg('Validating your design link...');
    orderInfo = await validateToken();
    if (!orderInfo) {
      hideLoadingOverlay();
      return;
    }

    updateLoadingMsg('Opening the product designer...');
    setStatus('Opening the product designer...');

    autoOpenFPD(function () {
      updateLoadingMsg('Waiting for designer to initialise...');

      waitForFPDReady(function () {
        updateLoadingMsg('Loading your product template...');

        // Prioritize fpdProductTitle over raw fpdConfig
        if (orderInfo.fpdProductTitle) {
          loadFPDConfig(orderInfo.fpdProductTitle);
        } else {
          loadFPDConfig(orderInfo.fpdConfig);
        }

        document.getElementById('artwork-submit-btn').addEventListener('click', submitDesign);
        document.getElementById('artwork-edit-btn').addEventListener('click', reopenFPD);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
